import React from 'react'

/**
 * SegmentedControl — small pill-grouped toggle for 2–3 mutually-exclusive
 * options (e.g. comment visibility «Всем» / «Команде»).
 */
export function SegmentedControl({ options, value, onChange, className = '' }) {
  const cls = ['segmented', className].filter(Boolean).join(' ')
  return (
    <div className={cls}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={value === opt.value ? 'active' : ''}
          onClick={() => onChange && onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  )
}
